import {
  Box,
  Step,
  StepLabel,
  Stepper,
  StepConnector,
  stepConnectorClasses,
  useTheme,
  StepIconProps,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface OnboardingStepperProps {
  activeStep: number;
  stepLabels: string[];
}

export const CustomStepIcon = ({
  active = false,
  completed = false,
}: StepIconProps) => {
  const theme = useTheme();
  if (completed) {
    return (
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          backgroundColor: theme.palette.brand.primary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CheckIcon sx={{ color: 'white', fontSize: 20 }} />
      </Box>
    );
  }

  const isActive = active;

  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: isActive ? `2px solid ${theme.palette.brand.primary}` : '2px solid transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: '50%',
          border: '2px solid',
          borderColor: isActive ?
            theme.palette.brand.primary :
            theme.palette.grey[300],
          backgroundColor: isActive ? theme.palette.brand.primary :
            theme.palette.common.white,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: isActive ?
              theme.palette.common.white :
              theme.palette.grey[300],
          }}
        />
      </Box>
    </Box>
  );
};

export const OnboardingStepper = ({
  activeStep,
  stepLabels,
}: OnboardingStepperProps) => {
  const theme = useTheme();

  const CustomConnector = (
    <StepConnector
      sx={{
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
          top: 16,
          left: 'calc(-90% + 16px)',
          right: `calc(10% + ${activeStep === 0 ? theme.spacing(1.5) : theme.spacing(2)})`,
        },
        [`& .${stepConnectorClasses.line}`]: {
          borderColor: theme.palette.brand.primary,
          borderTopWidth: 2,
          borderRadius: 1,
        },
      }}
    />
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper
        activeStep={activeStep} // index in stepLabels that's active
        alternativeLabel
        connector={CustomConnector}
      >
        {stepLabels.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepIcon}
              sx={{
                '&.MuiStepLabel-alternativeLabel': {
                  alignItems: index === 0 ? 'flex-start' : 'flex-end',
                },
                '& .MuiStepLabel-labelContainer': {
                  textAlign: index === 0 ? 'left !important' : 'right !important',
                  ...(index === 0 && { marginLeft: theme.spacing(-1) }),
                  ...(index !== 0 && { marginRight: theme.spacing(-1) }),
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
